module.exports = __webpack_public_path__ + "images/ce530e25d0c397259c5d6e6b20c084e70836eb493fabfcaef65e6104f19bd54d.svg";